import classes from './IconsCell.module.css'
import classesCell from './BodyCell.module.css'

export default function IconsCell({data}) {
    
    return <div className={`${classes.container} ${classesCell.body_cell}`}>
        <div className={`${classes.item} ${classes.item_green} ${data?.is_commercial_policy ? classes.active: ''}`}>
            <i className='ti ti-car'></i>
        </div>
        <div className={`${classes.item} ${classes.item_red} ${data?.is_dui ? classes.active: ''}`}>
            <i className='ti ti-glass-gin'></i>
        </div>
        <div className={`${classes.item} ${classes.item_red} ${data?.is_hit_run ? classes.active: ''}`}>
            <i className='ti ti-run'></i>
        </div>
    </div>
}